export default __webpack_public_path__ + "static/banner-three-shape3-66e8da5c6f0a024db5779899a0fb03e1.png";